import { Component, ElementRef, ViewChild, HostListener } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { DialogService } from '../../services/dialog-service';
import { LocalStorageService } from '../../services/local-storage.service';
import { ToastService, ToastType } from '../../services/toast.service';
import { ListingCheckoutService } from '../../services/listing-checkout.service';
import { MyListingsService } from '../../services/my-listings.service';
import { ListingService } from '../../services/listing.service';
import { StateList } from '../../shared/state-list';
import { Add_Plans } from '../../shared/plans';
import { environment } from 'src/environments/environment';
import { AppState } from 'src/app/app.state';
import constants from 'src/constants.json';
import { ActivityLoggerService } from 'src/app/services/activity-logger.service';
import { UserState } from 'src/state/user.state';

@Component({
  selector: 'app-plans-addon',
  templateUrl: './plans-addon.component.html',
  styleUrls: ['./plans-addon.component.css'],
})
export class PlansAddonComponent {
  features = [];
  mobFeatures = [];
  selectedPlanClass: String;
  checkSrc = '../../../assets/icons/check_green.svg';
  @ViewChild('scrollContainer') scrollContainer: ElementRef;
  viewportWidth: number;

  isScreenWidthLarge: boolean = false;

  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    this.viewportWidth = window.innerWidth;
    this.isScreenWidthLarge = window.innerWidth > 768;
  }

  constructor(
    private router: Router,
    public dialogService: DialogService,
    public localStorageService: LocalStorageService,
    public toastService: ToastService,
    public listingCheckoutService: ListingCheckoutService,
    public myListingsService: MyListingsService,
    public listingService: ListingService,
    private sanitizer: DomSanitizer,
    public appState: AppState,
    private activityLoggerService: ActivityLoggerService,
    private userState: UserState,
  ) { }

  historyState: any;
  plans: any;
  isButtonLoader: boolean = false;
  isLoader: boolean = false;
  selectedPlan: any;
  myListingId: string;
  brokerageValues: any;
  stateName: string;
  selectedMls = [];
  totalAmount: number = 0;
  activeTab: string;
  listingCheckoutEnabled: boolean;

  setActiveTab(tabName: string) {
    this.activeTab = tabName;
  }

  ngOnInit(): void {
    this.isScreenWidthLarge = window.innerWidth > 768;

    let currentCompany = this.appState.companyInfoValue;

    this.historyState = history.state;
    this.isButtonLoader = true;
    this.myListingId = this.historyState.myListingId
      ? this.historyState.myListingId
      : this.localStorageService.get('myListingId')
        ? this.localStorageService.get('myListingId')
        : null;

    if (
      !this.historyState ||
      !this.historyState.address ||
      this.historyState.isPaymentDone || currentCompany?.sellSideConfig?.hidePlanSelection
    ) {
      this.router.navigateByUrl('/my-listing');
      return;
    }

    if (this.listingCheckoutEnabled && !this.historyState.FIPS) {
      this.toastService.toast(
        'FIPS code missing!!!!, Complete Basic Home Details to get Plans and Add-Ons',
        ToastType.Error
      );
      this.router.navigateByUrl('/home-details', {
        state: this.historyState,
      });
      return;
    }

    // if (this.historyState.FIPS) {
    this.listingCheckoutService.GetListingCheckoutToken().subscribe({
      next: (res) => {
        if (res && res.access_token) {
          this.localStorageService.set('lcAccessToken', res.access_token);
          this.getPlanDetails();
        } else {
          this.isButtonLoader = false;
          console.log('GetListingCheckoutToken Fails!!!!');
        }
      },
      error: (err) => {
        this.isButtonLoader = false;
        console.log('GetListingCheckoutToken err : ', err);
      },
    });

    for (let index = 0; index < StateList.length; index++) {
      const element = StateList[index];
      if (element.value == this.historyState.StateOrProvince) {
        this.stateName = element.viewValue;
        break;
      }
    }

    this.viewportWidth = window.innerWidth;

    if (
      currentCompany?.sellSideConfig &&
      currentCompany?.sellSideConfig?.listingServiceProvider ==
      'ListingCheckout'
    ) {
      this.listingCheckoutEnabled = true;
    } else {
      this.listingCheckoutEnabled = false;
    }

  }

  mapPackageToServices(packages, orgServices) {
    for (let i = 0; i < orgServices.length; i++) {
      let service = orgServices[i];
      for (let index = 0; index < packages.length; index++) {
        let pack = packages[index];
        let eleServices = pack.services;
        if (
          eleServices[service.id] != null &&
          eleServices[service.id] != undefined
        ) {
          service[index + 1] = {
            content:
              eleServices[service.id] == true
                ? ''
                : eleServices[service.id] != null &&
                  eleServices[service.id] != false
                  ? eleServices[service.id]
                  : '',
            imageUrl: eleServices[service.id] == true ? this.checkSrc : null,
          };
        }
      }
      this.features.push(service);
    }

    for (let index = 0; index < packages.length; index++) {
      let mobService = [];
      let pack = packages[index];
      let eleServices = pack.services;
      for (let i = 0; i < orgServices.length; i++) {
        let service = orgServices[i];
        if (eleServices[service.id] == true) {
          mobService.push(service.text);
        } else if (eleServices[service.id] != false) {
          mobService.push(service.text + ' : ' + eleServices[service.id]);
        }
      }
      this.mobFeatures.push(mobService);
    }
  }

  getPlanDetails() {
    let fips = this.historyState.FIPS;

    if (fips && fips.length == 4) {
      fips = '0' + fips;
    }
    if (this.listingCheckoutEnabled) {
      this.listingCheckoutService.GetPackages(fips).subscribe({
        next: (res) => {
          if (res && res.packages && res.packages.length > 0) {
            this.plans = res.packages;
            // console.log("res.packages :", JSON.stringify(res.packages));
            // console.log("res.services :", JSON.stringify(res.services));
            // Add_Plans.packageid = this.plans[0].packageid;
            this.plans.push(Add_Plans);

            this.mapPackageToServices(res.packages, res.services);
            this.brokerageValues = res.values;
            if (this.historyState.plansData) {
              this.selectedPlan = this.historyState.plansData;
              for (let index = 0; index < this.plans.length; index++) {
                let element = this.plans[index];
                if (element.packageid == this.selectedPlan.packageid) {
                  element.isSelected = true;
                  this.selectedPlanClass = 'active_' + index.toString();
                  this.setActiveTab(element.name);
                } else {
                  element.isSelected = false;
                }
              }
            } else {
              this.setActiveTab(this.plans[0].name);
            }
            this.isButtonLoader = false;
          } else {
            this.isButtonLoader = false;
            console.log('GetPackages Fails!!!!&&&');
          }
        },
        error: (err) => {
          this.isButtonLoader = false;
          console.log('GetPackages err : ', err);
        },
      });
    } else {
      // get listing packages using the new listings service
      let currentCompany = this.appState.companyInfoValue;
      let state = this.historyState.StateOrProvince;
      let county = this.historyState.FIPS;

      this.listingService
        .GetListingPackages(currentCompany, state, county)
        .then((uiReadyPackages) => {
          this.plans = uiReadyPackages.plans;
          console.log(this.plans);

          this.features = uiReadyPackages.features;
          this.mobFeatures = uiReadyPackages.mobFeatures;

          if (this.historyState.plansData) {
            this.selectedPlan = this.historyState.plansData;
            for (let index = 0; index < this.plans.length; index++) {
              let element = this.plans[index];
              if (element.packageid == this.selectedPlan.packageid) {
                element.isSelected = true;
                this.selectedPlanClass = 'active_' + index.toString();
                this.setActiveTab(element.name);
              } else {
                element.isSelected = false;
              }
            }
          } else {
            this.setActiveTab(this.plans[0].name);
          }
          this.isButtonLoader = false;
        });
    }
  }

  back() {
    this.router.navigateByUrl('/photos', {
      state: this.historyState,
    });
  }

  getMlsServices() {
    if (this.selectedPlan) {
      this.isLoader = true;

      this.listingCheckoutService
        .GetMlSs(this.selectedPlan.packageid, null)
        .subscribe({
          next: (res) => {
            if (res && res.length > 0) {
              for (let index = 0; index < res.length; index++) {
                let element = res[index];
                if (element.price == 0) {
                  element.isDefault = true;
                } else {
                  element.isDefault = false;
                }

                if (element.lockbox) {
                  element.lockbox.isLockIncluded = false;
                }

                if (element.included) {
                  element.isIncluded = true;
                  this.selectedMls.push(element);
                  this.calculateTotal();
                } else {
                  element.isIncluded = false;
                }
                element.price =
                  element.price && element.price != '' ? element.price : 0;
                // this.mlsService.push(element);
              }
              this.calculateTotal();
              this.continue();
            } else {
              this.calculateTotal();
              this.continue();
            }
          },
          error: (err) => {
            this.calculateTotal();
            this.continue();
          },
        });
    } else {
      this.toastService.toast('Choose a Plan to Continue', ToastType.Error);
    }
  }

  calculateTotal() {
    this.totalAmount = this.selectedPlan.price;

    for (let index = 0; index < this.selectedMls.length; index++) {
      let element = this.selectedMls[index];
      this.totalAmount = this.totalAmount + element.price;
    }
  }

  learnMore() {
    let url = this.appState.companyInfoValue?.sellSideConfig?.websiteUrl + '/full-service';
    window.open(url);
    let updateInput = {
      updatedDate: new Date(),
      isDefaultPlanChoosen: true,
    };
    this.myListingsService
      .UpdateListing(this.myListingId, updateInput)
      .subscribe({
        next: (res) => { },
        error: (err) => {
          console.log('UpdateListing err!!!!');
          console.log(err);
        },
      });
  }

  continue() {
    if (this.selectedPlan) {
      this.isLoader = true;

      let updateInput = {
        updatedDate: new Date(),
      };
      if (
        !this.historyState.completedIndex ||
        this.historyState['completedIndex'] < 2
      ) {
        updateInput['stage'] = 2;
        // updateInput['stageName'] = 'Plans';
      }

      if (this.historyState.stageName) {
        if (this.historyState.stageName.split(',').indexOf('Plans') <= -1) {
          updateInput['stageName'] =
            'Plans' + ',' + this.historyState.stageName;
        }
      } else {
        updateInput['stageName'] = 'Plans' + ',' + 'Home Details';
      }

      updateInput['plansData'] = this.selectedPlan;
      updateInput['totalAmount'] = this.totalAmount;
      updateInput['mlsData'] = this.selectedMls;
      updateInput['addOnsData'] = [];
      updateInput['isDefaultPlanChoosen'] = false;

      this.myListingsService
        .UpdateListing(this.myListingId, updateInput)
        .subscribe({
          next: (res) => {
            if (
              !this.historyState.completedIndex ||
              this.historyState['completedIndex'] < 2
            ) {
              this.historyState['completedIndex'] = 2;
            }
            this.historyState['plansData'] = this.selectedPlan;
            this.historyState['totalAmount'] = this.totalAmount;
            this.historyState['addOnsData'] = [];
            this.historyState['mlsData'] = this.selectedMls;
            this.historyState['from'] = 'plans';
            this.historyState.stageName = updateInput['stageName'];

            this.isLoader = false;

            let userType = this.userState?.getUserDetails?.userType;
            if (userType == 'investor') {
              let userId = this.userState?.getUserDetails?.id;
              let loggerParams = {
                category: constants.LOGGER.listMyProperty.category,
                action: constants.LOGGER.listMyProperty.action.viewPaymentSummary.key,
                data: {
                  userId: userId,
                  propertyId: this.historyState.listingDetails?.PMXPropertyId
                }
              };
              this.activityLoggerService.updateActivityLog(loggerParams).subscribe({
                next: (res) => {

                },
                error: (err) => {

                  console.log(err);
                },
              });
            }

            this.router.navigateByUrl('/review', {
              state: this.historyState,
            });
          },
          error: (err) => {
            console.log('UpdateListing err!!!!');
            this.isLoader = false;
            console.log(err);
          },
        });
    } else {
      this.toastService.toast('Choose a Plan to Continue', ToastType.Error);
    }
  }

  onCheckboxChange(value, from) {
    // this.selectedPlanClass = 'essentials';
    this.selectedPlan = null;
    this.selectedPlanClass = 'unSelected';
    for (let index = 0; index < this.plans.length; index++) {
      let element = this.plans[index];
      if (element.packageid == from && value) {
        element.isSelected = true;
        this.selectedPlanClass = 'active_' + index.toString();
        this.selectedPlan = element;
      } else {
        element.isSelected = false;
      }
    }
  }
  convertToHtml(str: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(str);
  }
}
